import { initialize } from "./template";

initialize({
  authentication: {
    enabled: true
  },
});
